class NewsletterExtendAction extends ValidatorForm.Action { // eslint-disable-line
	submitAction (event) {
		this.validatorClass.mode = 'async'
		event.preventDefault()
		this.pageClass.validate(true).then(value => {
			if (value) {
				if (this.validatorClass.hasCaptcha) {
					this.validatorClass.captcha.run()
				} else {
					this.pageClass.submitForm()
				}
			} else {
				this.disableAction()
				return false
			}
		}).catch(value => {
			console.warn(value)
		})
	}
}
window.NewsletterExtendAction = NewsletterExtendAction

class NewsletterEventHandlers extends ValidatorForm.EventHandlers { // eslint-disable-line

	asyncFailed (url, response) {
		if (+response.code === 3) {
			if (document.querySelector('#newsletter-code-3')) {
				document.querySelector('#newsletter-code-3').classList.remove('d-none')
				setTimeout(function () {
					document.querySelector('#newsletter-code-3').classList.add('d-none')
				}, 3000)
			}
		}
		if (+response.code === 5) {
			if (document.querySelector('#newsletter-code-7')) {
				document.querySelector('#newsletter-code-7').classList.remove('d-none')
				setTimeout(function () {
					document.querySelector('#newsletter-code-7').classList.add('d-none')
				}, 3000)
			}
		}
		if (+response.code === 2) {
			if (document.querySelector('#newsletter-code-2')) {
				document.querySelector('#newsletter-code-2').classList.remove('d-none')
				setTimeout(function () {
					document.querySelector('#newsletter-code-2').classList.add('d-none')
				}, 3000)
			}
		}
		if (+response.code === 5) {
			if (document.querySelector('#newsletter-code-5')) {
				document.querySelector('#newsletter-code-5').classList.remove('d-none')
				setTimeout(function () {
					document.querySelector('#newsletter-code-5').classList.add('d-none')
				}, 3000)
			}
		}
		if (+response.code === 0) {
			if (document.querySelector('#newsletter-code-0')) {
				document.querySelector('#newsletter-code-0').classList.remove('d-none')
				setTimeout(function () {
					document.querySelector('#newsletter-code-0').classList.add('d-none')
				}, 3000)
			}
		}
		if (+response.code === 1) {
			if (document.querySelector('#newsletter-code-1')) {
				document.querySelector('#newsletter-code-1').classList.remove('d-none')
				setTimeout(function () {
					document.querySelector('#newsletter-code-1').classList.add('d-none')
				}, 3000)
			}
		}
		if (+response.code === 10) {
			if (document.querySelector('#newsletter-code-10')) {
				document.querySelector('#newsletter-code-10').classList.remove('d-none')
				setTimeout(function () {
					document.querySelector('#newsletter-code-10').classList.add('d-none')
				}, 3000)
			}
		}
	}
}
window.NewsletterEventHandlers = NewsletterEventHandlers



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_acym_rs/script.js